module.exports = __webpack_public_path__ + "static/media/Icon_left_arrow.8533fdad.svg";